<div
  class="nav-bar"
  [class.dark-theme]="isDarkTheme"
  [class.dock-on-right]="dockSide === 'right'"
  [class.is-dragging]="isDraggingDock"
  style="height: var(--dvh, 100vh); min-height: var(--dvh, 100vh); overflow: hidden;">
  <canvas class="bgfx-orchestra" aria-hidden="true"></canvas>
  <div class="bgfx-labels" aria-hidden="true">
    <span class="bgfx-label bgfx-a">transient</span>
    <span class="bgfx-label bgfx-b">scheduler</span>
    <span class="bgfx-label bgfx-c">validator</span>
    <span class="bgfx-label bgfx-d">retrieve</span>
    <span class="bgfx-label bgfx-e">persist</span>
    <span class="bgfx-label bgfx-f">oopschestrator</span>
    <span class="bgfx-label bgfx-g">working...</span>
    <span class="bgfx-label bgfx-h">translate</span>
    <span class="bgfx-label bgfx-i">integrate</span>
  </div>

  <div class="drop-preview drop-left" [class.active]="isDraggingDock && previewSide === 'left'"></div>
  <div class="drop-preview drop-right" [class.active]="isDraggingDock && previewSide === 'right'"></div>

  <button
    mat-icon-button
    class="mobile-menu-toggle"
    *ngIf="isMobileLayout"
    (click)="toggleSidebar()"
    aria-label="Toggle navigation menu">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-sidenav-container class="app-shell" [autosize]="true">
    <mat-sidenav
      [mode]="isMobileLayout ? 'over' : 'side'"
      [opened]="isMobileLayout ? isMobileDrawerOpen : true"
      [position]="dockSide === 'right' ? 'end' : 'start'"
      class="sidenav dock-sidenav"
      [style.width]="sidenavWidth"
      [style.overflow]="'visible'">

      <nav
        class="futuristic-dock"
        aria-label="Dashboard navigation"
        [class.shrunk]="shrinkDock"
        [class.dock-right]="dockSide === 'right'"
        [class.dragging]="isDraggingDock"
        (mouseenter)="shrinkDock = false"
        (click)="$event.stopPropagation()">
        <button
          type="button"
          class="dock-handle"
          (mousedown)="startDockDrag($event)"
          aria-label="Drag navigation dock"
          title="Drag to move dock">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </button>

        <!-- <button
          type="button"
          class="dock-logo"
          matTooltip="SIM FOUNDRY"
          [matTooltipPosition]="dockSide === 'right' ? 'left' : 'right'"
          aria-label="SIM FOUNDRY">
          <span>3.0</span>
        </button> -->

        <button
          #userAvatar
          type="button"
          class="user-avatar"
          [class.active]="accountOpen"
          (mouseenter)="openAccountCardHover()"
          (mouseleave)="closeAccountCardHover()"
          (click)="openAccountCardHover()"
          aria-label="Account">
          <span>{{ getUserInitials() }}</span>
        </button>

        <div class="dock-links">
          <ng-container *ngFor="let item of menuItems; let itemIndex = index">
            <button
              type="button"
              *ngIf="!hasChildren(item)"
              class="dock-link"
              [class.active]="isActive(item)"
              [class.is-disabled]="isItemDisabled(item)"
              [attr.aria-label]="item.name"
              [attr.aria-disabled]="isItemDisabled(item)"
              (mouseenter)="onRailItemHover(item)"
              (mouseleave)="clearHoverNavigation()"
              (focus)="onRailItemHover(item)"
              (blur)="clearHoverNavigation()"
              (click)="navigateToMenuItem(item)">
              <mat-icon>{{ item.icon || 'dashboard' }}</mat-icon>
              <span class="dock-tooltip">{{ item.name }}</span>
            </button>

            <button
              type="button"
              *ngIf="hasChildren(item)"
              class="dock-link"
              [class.active]="isMenuActive(item)"
              [class.menu-open]="isMenuExpanded(item.name)"
              [class.is-disabled]="isItemDisabled(item)"
              [attr.aria-label]="item.name"
              [attr.aria-disabled]="isItemDisabled(item)"
              (mouseenter)="openMenuOnHover(item)"
              (mouseleave)="clearHoverNavigation()"
              (focus)="openMenuOnHover(item)"
              (blur)="clearHoverNavigation()"
              (click)="toggleSubmenu(item.name, $event)">
              <mat-icon>{{ item.icon || 'folder' }}</mat-icon>
              <span class="dock-tooltip">{{ item.name }}</span>
            </button>

            <div
              class="dock-submenu"
              *ngIf="hasChildren(item) && isMenuExpanded(item.name)">
              <button
                type="button"
                *ngFor="let child of getMenuChildren(item)"
                class="dock-subitem"
                [class.active]="isActive(child)"
                [class.is-disabled]="isItemDisabled(child)"
                [attr.aria-disabled]="isItemDisabled(child)"
                (mouseenter)="scheduleHoverNavigation(child)"
                (mouseleave)="clearHoverNavigation()"
                (focus)="scheduleHoverNavigation(child)"
                (blur)="clearHoverNavigation()"
                (click)="navigateToMenuItem(child)">
                <mat-icon>{{ child.icon || 'chevron_right' }}</mat-icon>
                <span>{{ child.name }}</span>
              </button>
            </div>
          </ng-container>
        </div>

        <div class="dock-bottom">
          <button
            type="button"
            class="dock-link btn-notif"
            [class.active]="notificationsOpen"
            (mouseenter)="openNotificationsHover()"
            (mouseleave)="closeNotificationsHover()"
            (click)="openNotificationsHover()"
            aria-label="Notifications">
            <mat-icon>notifications</mat-icon>
            <span class="notif-badge" *ngIf="notificationCount">{{ notificationCount }}</span>
            <!-- <span class="dock-tooltip">Notifications</span> -->
          </button>

          <button
            type="button"
            class="dock-link settings-dock-link"
            [class.active]="settingsOpen"
            (mouseenter)="openSettingsHover()"
            (mouseleave)="closeSettingsHover()"
            (click)="openSettingsHover()"
            aria-label="Settings">
            <mat-icon>settings</mat-icon>
            <!-- <span class="dock-tooltip">Settings</span> -->
          </button>
        </div>
      </nav>
    </mat-sidenav>

    <mat-sidenav-content class="app-content" [class.route-transitioning]="isRouteTransitioning">
      <div
        class="app-page"
        [class.has-welcome-header]="shouldShowWelcomeHeader"
        [style.padding]="contentPadding"
        [style.height]="contentHeight"
        [style.min-height]="contentMinHeight"
        (mouseenter)="shrinkDock = true">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <div
    class="settings-popover appearance-popover"
    [class.open]="settingsOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    (mouseenter)="openSettingsHover()"
    (mouseleave)="closeSettingsHover()"
    (click)="$event.stopPropagation()">
    <div class="appearance-title">Appearance</div>

    <div class="appearance-label">Mode</div>
    <div class="theme-mode-row" role="group" aria-label="Theme mode">
      <button
        type="button"
        class="theme-choice"
        *ngFor="let mode of themeModeOptions"
        [class.active]="isThemeModeSelected(mode.id)"
        (click)="selectThemeMode(mode.id)">
        <mat-icon>{{ mode.icon }}</mat-icon>
        <span>{{ mode.label }}</span>
      </button>
    </div>

    <div class="appearance-label accent-label">Accent</div>
    <div class="accent-choice-row" role="group" aria-label="Theme accent">
      <button
        type="button"
        class="accent-choice"
        *ngFor="let accent of accentOptions"
        [class.active]="selectedAccentId === accent.id"
        (click)="selectAccent(accent)">
        <span class="accent-dot" [style.background]="accent.color"></span>
        <span>{{ accent.label }}</span>
      </button>
    </div>

    <div class="appearance-footer" *ngIf="hasPendingThemePreview">
      <button type="button" class="save-theme-chip" (click)="saveThemePreview()">
        <mat-icon>save</mat-icon>
        <span>Save theme</span>
      </button>
    </div>
  </div>
  <div
    class="notif-popover"
    [class.open]="notificationsOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    (mouseenter)="openNotificationsHover()"
    (mouseleave)="closeNotificationsHover()"
    (click)="$event.stopPropagation()">
    <div class="notif-head">
      <div>
        <div class="popover-title">Notifications</div>
        <div class="popover-subtitle">{{ notificationCount }} unread</div>
      </div>
      <button type="button" class="text-action" (click)="clearNotifications()">Clear</button>
    </div>
    <button
      type="button"
      class="notif-item"
      *ngFor="let notification of notifications"
      [class.read]="notification.read"
      (click)="markNotificationRead(notification)">
      <span
        class="notif-dot"
        [class.alert]="notification.type === 'alert'"
        [class.info]="notification.type === 'info'"
        [class.success]="notification.type === 'success'"></span>
      <span>
        <strong>{{ notification.title }}</strong>
        <small>{{ notification.time }}</small>
      </span>
    </button>
    <div class="empty-popover" *ngIf="!notifications.length">No notifications</div>
  </div>

  <div
    class="account-popover"
    [class.open]="accountOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    [style.top]="popoverPos.top"
    [style.left]="popoverPos.left"
    (mouseenter)="openAccountCardHover()"
    (mouseleave)="closeAccountCardHover()"
    (click)="$event.stopPropagation()">
    <div class="ac-identity">
      <div class="ac-avatar">{{ getUserInitials() }}</div>
      <div>
        <div class="ac-name">{{ username || 'Application User' }}</div>
        <div class="ac-email">DVM Platform</div>
      </div>
    </div>
    <div class="ac-role-chip">
      <mat-icon>verified_user</mat-icon>
      <span>Signed in</span>
    </div>
    <div class="ac-divider"></div>
    <button type="button" class="ac-logout-btn" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </div>
</div>

